import { render, staticRenderFns } from "./ManageTaskModal.vue?vue&type=template&id=48576578&"
import script from "./ManageTaskModal.vue?vue&type=script&lang=js&"
export * from "./ManageTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageTaskModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports